module.exports = __webpack_public_path__ + "img/mall.338380fb.svg";